<template>
  <div class="exam">
    <div class="nuv">
      <span>群培训管理&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <a href="javascript:;" class="top-button"><el-button type="primary">群考核名单</el-button></a>
    <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
    <el-button type="danger" style="margin-left: 10px;" @click="getList">查询淘金客</el-button>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length" style="padding-top: 45px;">暂无记录！</p>
      <template v-else>
        <el-table ref="multipleTable" border :data="list" :height="onlineTableHeight" tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column prop="realName" label="考核人员" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
          <el-table-column label="是否通过" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.retrialState" placeholder="请选择">
                <el-option key="Passed" label="通过" value="Passed"></el-option>
                <el-option key="InRetrial" label="复训中" value="InRetrial"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="passRemark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" autosize placeholder="不能超过200字" v-model="scope.row.passRemark" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="tj-margin-top-xl">
          <el-button type="primary" @click="saveScore">保存打分</el-button>
          <el-button type="danger" @click="releaseGroup">发布成绩</el-button>
        </div>
      </template>
    </template>
    <!-- 发布成绩弹出层 -->
    <Modal ref="release">
      <h3 style="text-align: center;margin-bottom: 10px;">所有通过学员将被T出本群，且建议复训通过。</h3>
      <div class="tj-table tj-fill tj-padding-right-xl">
        <dl>
          <dt class="tj-text-right"><font color="red">*</font> 发送消息：</dt>
          <dd>
            <el-input type="textarea" :rows="3" placeholder="恭喜你通过基础复训，赶快去领取任务吧。" v-model="release.publishMsg"></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'retrialGroupId': this.$route.query.groupId,
      'tjkId': '', //搜索的淘金客id
      'multipleSelection': [],
      'release': {
        'publishMsg': '恭喜你通过基础复训，赶快去领取任务吧。'
      },
      'groupName': '', //考核群名称
      'list': [],
      'onlineTableHeight': window.innerHeight - 220
    }
  },
  mounted: function() {
    this.getList()
  },
  methods: {
    getList() {
      var data = {
        'retrialGroupId': this.retrialGroupId,
        'tjkId': this.tjkId
      }
      this.$http.post(API_ROOT.college + '/retrialRecord/queryList', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.groupName = result.data.groupName
          this.list = result.data
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //保存打分
    saveScore() {
      var self = this,
          ids = [],
          isOk = true //表单是否校验通过

      self.list.map((item)=> {
        if(!!item.passRemark && item.passRemark.length > 200) {
          self.$alert('备注不能超过200字')
          isOk = false
          return false
        }
      })
      self.list.map((item)=> {
        if(!!item.retrialState) {
          ids.push({
            'retrialRecordId': item.retrialRecordId,
            'retrialState': item.retrialState,
            'passRemark': !!item.passRemark ? item.passRemark : ''
          })
        }
      })

      if(isOk) {
        self.$http.post(API_ROOT.college + '/retrialRecord/updateRetrialRecords', {'retrialRecordList': ids}).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.getList()
          } else {
            self.$alert(result.msg)
            self.getList()
          }
        }, response => {
          self.$alert('网络繁忙，请稍后重试！')
        })
      }
    },
    //发布成绩
    releaseGroup() {
      var self = this
      self.release.publishMsg = '恭喜你通过基础复训，赶快去领取任务吧。'
      //筛选状态有值的淘金客
      var ids = []
      if(self.multipleSelection.length > 0) {
        self.multipleSelection.map((item)=> {
          ids.push(item.retrialRecordId)
        })
      }
      this.$refs.release.open({
        title: '发布成绩',
        width: 600,
        callBack: function (arg) {
          if (arg.type === 'cancel') {
            arg.close()
            return
          }
          if(self.release.publishMsg == '') {
            self.$alert('发送消息不能为空')
            return false
          }
          if (arg.pending()) return
          arg.pending(true)

          var data = {
            'retrialGroupId': self.retrialGroupId,
            'publishMsg': self.release.publishMsg,
            'retrialRecordIds': ids
          }
          self.$http.post(API_ROOT.college + '/retrialRecord/publishRetrialRecord', data).then(response => {
            arg.pending(false)
            var result = response.data
            if(result.success) {
              self.$message({
                message: '已发布',
                type: 'success',
                center: true,
                duration: 1000
              })
              arg.close()
              self.getList()
            } else {
              self.$alert(result.msg)
              self.getList()
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //淘金客自动搜索
    updateTjkId(val) {
      this.tjkId = val
    }
  }
}
</script>
<style type="less" scoped>
.nuv {
  font-size: 16px;
}
.top-button {
  margin: 10px 15px 20px 0;
  display: inline-block;
}
.tab > li {
  float: left;
  padding: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}
.tab > li.active {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  color: #ffffff;
  cursor: pointer;
}
.tab > li.active:hover {
  background-color: #409EFF;
}
.tab > li.active:hover > a {
  color: #ffffff;
}
.tip-box {
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 1px solid #80a9f5;
  text-align: center;
  margin-right: 20px;
}
.tip-con {
  font-size: 14px;
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/college/retrialExamine.vue